import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57dee6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "disabled", "readonly", "maxlength", "minlength", "value", "placeholder", "title"]
const _hoisted_4 = {
  key: 0,
  class: "character-count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(['label', _ctx.disabled ? 'disabled' : '', _ctx.required ? 'required' : '']),
      for: _ctx.id
    }, _toDisplayString(_ctx.label), 11, _hoisted_2),
    _createElementVNode("input", {
      type: "text",
      id: _ctx.id,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      maxlength: _ctx.maxLength,
      minlength: _ctx.minLength,
      value: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      title: _ctx.title,
      class: "input",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.maskInput && _ctx.maskInput(...args)))
    }, null, 40, _hoisted_3),
    (_ctx.hasCharacterCounter)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.modelValue ? _ctx.modelValue.length : 0) + " " + _toDisplayString(_ctx.maxLength ? " /" + _ctx.maxLength : ""), 1))
      : _createCommentVNode("", true)
  ]))
}